import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const QuoteEndIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const className = customColour ? '' : 'defaultColor'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g data-testid="icon-quoteEnd" fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <path
          d="M12.59375,10.3529412 C14.40625,10.3529412 15.84375,9.0872211 15.84375,7.20486815 C15.84375,5.51724138 14.8125,4.51115619 13.375,4.15415822 L12.0625,4.15415822 C12.21875,2.336714 13.78125,0.61663286 16,0.292089249 L16,0 C12.3125,0.129817444 9,2.53144016 9,6.1663286 C9,8.60040568 10.40625,10.3529412 12.59375,10.3529412 Z M3.86554622,10.3529412 C5.81512605,10.3529412 7.36134454,9.0872211 7.36134454,7.20486815 C7.36134454,5.51724138 6.25210084,4.51115619 4.70588235,4.15415822 L3.29411765,4.15415822 C3.46218487,2.336714 5.14285714,0.61663286 7.52941176,0.292089249 L7.52941176,0 C3.56302521,0.129817444 0,2.53144016 0,6.1663286 C0,8.60040568 1.51260504,10.3529412 3.86554622,10.3529412 Z"
          fill={customColour}
          className={styles[className]}
          transform="translate(8.000000, 5.176471) scale(-1, -1) translate(-8.000000, -5.176471) "
        />
      </g>
    </Icon>
  )
}
